/**
 * Identifiant d’appareil stable (navigateur / WebView) pour lier un nom d’utilisateur mémorisé.
 * Stockage local uniquement — pas d’empreinte serveur.
 */

const DEVICE_ID_KEY = 'entrea_mobile_device_id_v1';
const DEVICE_USERNAME_KEY = 'entrea_mobile_device_username_v1';

function randomId() {
  try {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
  } catch {
    /* ignore */
  }
  return `d-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
}

export function getOrCreateMobileDeviceId() {
  try {
    let id = String(localStorage.getItem(DEVICE_ID_KEY) || '').trim();
    if (!id) {
      id = randomId();
      localStorage.setItem(DEVICE_ID_KEY, id);
    }
    return id;
  } catch {
    return randomId();
  }
}

/** Enregistre le dernier identifiant IAM utilisé pour la connexion mobile sur cet appareil. */
export function saveMobileDeviceUsername(username) {
  const u = String(username || '').trim();
  if (!u) return;
  try {
    const deviceId = getOrCreateMobileDeviceId();
    localStorage.setItem(
      DEVICE_USERNAME_KEY,
      JSON.stringify({
        deviceId,
        username: u,
        savedAt: new Date().toISOString(),
      })
    );
  } catch {
    /* ignore */
  }
}

/** Lit l’identifiant mémorisé si la même entrée appareil correspond. */
export function readMobileDeviceUsername() {
  try {
    const deviceId = getOrCreateMobileDeviceId();
    const raw = localStorage.getItem(DEVICE_USERNAME_KEY);
    if (!raw) return '';
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return '';
    if (String(parsed.deviceId || '') !== deviceId) return '';
    return String(parsed.username || '').trim();
  } catch {
    return '';
  }
}

export function clearMobileDeviceUsername() {
  try {
    localStorage.removeItem(DEVICE_USERNAME_KEY);
  } catch {
    /* ignore */
  }
}
